// third party scripts
// constants
import storageNames from '../constants/storageNames'
import gigyaApi from '../third-party/gigya_api'

export const validIfGigyaIsReady = data => {
	if (!data || !data.accounts || !data.socialize || !data.accounts.showScreenSet) return false
	if (typeof data.accounts.showScreenSet !== 'function') return false
	return true
}

if (!validIfGigyaIsReady(window.gigya)) {
	gigyaApi()
}

const getUID = res => {
	if ((res.user != null || res.data !== null) && res.isVerified) {
		localStorage.setItem(storageNames.gigyaUID, res.UID)
	}
	localStorage.removeItem(storageNames.gigyaUID)
}

const getLogout = response => {
	getUID(response)
}

export const logoutGigya = async () => {
	return await window.gigya.accounts.logout({ callback: getLogout })
}
